import { render, staticRenderFns } from "./DetallesGanador.vue?vue&type=template&id=98e4a3a2"
import script from "./DetallesGanador.vue?vue&type=script&lang=js"
export * from "./DetallesGanador.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports